import styled from 'styled-components';

import { Sorare } from 'atoms/icons/Sorare';

export const FootballLogo = styled(Sorare)`
  color: var(--c-blue-400);
  fill: var(--c-black);
`;
